import createPersistedState from 'use-persisted-state';

const KEY = 'sbly-tools:actor-name';
const useActorNameState = createPersistedState(KEY);

/** The display name stamped on Google Watchdog writes (attribution, not authorization). */
export default function useActorName(): [string, (name: string) => void] {
  const [name, setName] = useActorNameState<string>('');
  return [name, setName];
}

/** Non-hook accessor for the service layer (same key use-persisted-state writes). */
export function getActorName(): string {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '""');
  } catch {
    return '';
  }
}
